import { render, staticRenderFns } from "./Trusted.vue?vue&type=template&id=ed39d1e4&scoped=true"
import script from "./Trusted.vue?vue&type=script&lang=js"
export * from "./Trusted.vue?vue&type=script&lang=js"
import style0 from "./Trusted.vue?vue&type=style&index=0&id=ed39d1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed39d1e4",
  null
  
)

export default component.exports